import type { ReactNode } from 'react';

import {
  Conversation,
  ConversationContent,
  ConversationScrollButton,
} from '@/modules/ui/components/conversation/Conversation';

interface ChatScreenProps {
  children: ReactNode;
  /** Pinned under the messages: the message box and anything said about it. */
  footer: ReactNode;
}

/** The chat page's frame: the messages scroll and follow new ones, the box stays at the bottom. */
export function ChatScreen({ children, footer }: ChatScreenProps) {
  return (
    <>
      {/* Opens at the newest message: scrolling down to it on every open would only slow the chat down. */}
      <Conversation className="min-h-0 flex-1" initial="instant">
        <ConversationContent className="mx-auto w-full max-w-[760px] px-4 pt-10 pb-6 md:px-10">
          {children}
        </ConversationContent>
        <ConversationScrollButton />
      </Conversation>
      <div className="mx-auto flex w-full max-w-[760px] flex-col gap-2 px-4 pb-6 md:px-10">
        {footer}
      </div>
    </>
  );
}
